import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import MiniSearch from "minisearch";
import loadText from "../../Core/loadText";
import { IndexType } from "./Types";
import joinUrl from "./joinUrl";

// Text search query

/**
 * An index for searching arbirtray text.
 *
 * We use the Minisearch library for indexing and searching free text.  The
 * index files contains a serialized JSON representation of the Minisearch
 * instance and the options used to construct the Minisearch instance.
 */
export default class TextIndex {
  /**
   * Construct the search index.
   *
   * @param url Url of the text index file
   */
  constructor(url) {
    this.url = url;
    _defineProperty(this, "type", IndexType.text);
    _defineProperty(this, "miniSearchIndex", void 0);
  }

  /**
   * Loads the text index.
   *
   * @param indexRootUrl The URL of the index root directory.
   * @param _valueHint Ignored for TextIndex.
   */
  async load(indexRootUrl, _valueHint) {
    if (this.miniSearchIndex) return;
    const promise = loadText(joinUrl(indexRootUrl, this.url)).then(text => JSON.parse(text)).then(json => MiniSearch.loadJS(json.index, json.options));
    this.miniSearchIndex = promise;
    return promise.then(() => {});
  }

  /**
   * Search the text index for the given value.
   *
   * @param value         The value to be searched.
   * @param queryOptions  MiniSearch.SearchOptions
   * @param return The IDs of objects matching the search text.
   */
  async search(value, queryOptions) {
    if (this.miniSearchIndex === undefined) throw new Error("Text index not loaded");
    const miniSearchIndex = await this.miniSearchIndex;
    const results = miniSearchIndex.search(value, queryOptions);
    const ids = new Set(results.map(r => r.id));
    return ids;
  }
}